<template>
    <div v-if="showErrorPop">
        <v-dialog/>
    </div>
</template>

<script>
export default {
    name: "ErrorPopup",
    data() {
        return {
        }   
    },
    components: {
    },
    watch: {
        showErrorPop(newValue) {
            if (newValue) {
                this.openAlert('시스템 메세지', this.$store.state.Error.errMsg)
            }

        }
    },
    create() {
    },
    mounted() {
    },
    computed: {
        showErrorPop() {
            return this.$store.state.Error.showErrorConfirm
        }
    },
    methods: {
        /** 
         * Function    : openAlert
         * Description : 시스템 에러 기본 팝업
         **/
        openAlert(title, message) {
            this.$modal.show('dialog', {
                title: title,
                text: message,
                buttons: [{
                    title: '확인',
                    class: 'primary-button',
                    handler: () => {
                        this.$store.state.Error.showErrorConfirm = false
                        this.$modal.hide('dialog')
                    }
                }]
            })
       } 
    },
}
</script>

<style scoped>

</style>